export const types = {
  news: 'news',
  event: 'event',
  class: 'class',
  partner: 'partner',
  course: 'course',
  spo: 'spo',
  training: 'training'
}

export const typeTranslates = {
  news: 'Новость',
  event: 'Мероприятие',
  class: 'ГП-класс',
  partner: 'ВУЗ-партнер',
  course: 'Курс',
  spo: 'СПО',
  training: 'Тренажер'
}
